var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

initGorgiasChatPromise.then(function() {
  window.toggleChat = function() {
    if (!GorgiasChat.isOpen()) {
      GorgiasChat.open();
      var chatButton = document.querySelector('#gorgias-chat-container iframe#chat-button');
      if(chatButton){
        chatButton.style.display = "block";
        chatButton.style.opacity = "1";
        chatButton.style.transition = "opacity 0.5s ease";
      }
    } else {
      GorgiasChat.close();
    }
  }

  GorgiasChat.on('widget:closed', function() {
    var chatButton = document.querySelector('#gorgias-chat-container iframe#chat-button');
    if(chatButton){
      chatButton.style.opacity = "0";
      setTimeout(function() {
        chatButton.style.display = "none";
      }, 500); // Wait for the transition to finish before hiding the button
    }
  });
});